import React from "react";
import {
  Grid,
  Snackbar,
  ButtonGroup,
  Avatar,
  Card,
  CardHeader,
  CardContent,
  Box,
  CardActions,
  Fab,
} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
  TwitterShareButton,
  FacebookMessengerShareButton,
} from "react-share";
import {
  EmailIcon,
  FacebookIcon,
  LinkedinIcon,
  WhatsappIcon,
  TwitterIcon,
  FacebookMessengerIcon,
} from "react-share";
import Typography from "@material-ui/core/Typography";
import { useTranslation } from "react-i18next";
import { appConifg } from "../../config/default";

function ShareAddressComponent(props) {
  const ICONS_SIZE = 38;
  const { t, i18n } = useTranslation("ShareAddressComponent");

  const store_addressDetailsData = props.store_addressDetailsData;
  const setShareOpen = props.setShareOpen;
  const lang = props.lang;

  const isLangArActive = (lang === "ar");

  const AddNum = store_addressDetailsData.addressId;
  const StNameEn = store_addressDetailsData.streetNameEnglish;
  const StNameAr = store_addressDetailsData.streetNameArabic;
  const AreaEn = store_addressDetailsData.areaNameEn;
  const AreaAr = store_addressDetailsData.areaNameAr;
  const PostalCode = store_addressDetailsData.postalCode;

  const addressStringEn = `${AddNum},${StNameEn},${AreaEn},${PostalCode}`;
  const addressStringAr = `${AddNum},${StNameAr},${AreaAr},${PostalCode}`;

  //const addressString = isLangArActive ? addressStringAr : addressStringEn;
  //const shareTextPrefix = t("ShareTextPrefix");
  // const shareHashTag = t("ShareHashTag");
  // const shareSummary = t("ShareSummary");
  const BASE_ADDRESS_SHARE_LINK = appConifg.Address.ShareAddressBaseUrl;
  const addressLink = `${BASE_ADDRESS_SHARE_LINK}${store_addressDetailsData.addressPointId}&lang=${lang}`;

  //const shareText = `${shareTextPrefix}  ${addressString}`;

  const NEWLINE_CHAR = '\n';
  const GreetingsTxt = t("GreetingsTxt");
  const BuildingNoTxt = t("BuildingNoTxt");
  const StreetTxt = t("StreetTxt");
  const AreaTxt = t("AreaTxt");
  const PostalCodeTxt = t("PostalCodeTxt");
  const AddressLinkTxt = t("AddressLinkTxt");

  const formatedAddressMessageEn = `${GreetingsTxt} ${NEWLINE_CHAR} ${BuildingNoTxt} ${AddNum} ${NEWLINE_CHAR} ${StreetTxt} ${StNameEn} ${NEWLINE_CHAR} ${AreaTxt} ${AreaEn} ${NEWLINE_CHAR} ${PostalCodeTxt} ${PostalCode} ${NEWLINE_CHAR} ${AddressLinkTxt} ${NEWLINE_CHAR} `;
  const formatedAddressMessageAr = `${GreetingsTxt} ${NEWLINE_CHAR} ${BuildingNoTxt} ${AddNum} ${NEWLINE_CHAR} ${StreetTxt} ${StNameAr} ${NEWLINE_CHAR} ${AreaTxt} ${AreaAr} ${NEWLINE_CHAR} ${PostalCodeTxt} ${PostalCode} ${NEWLINE_CHAR} ${AddressLinkTxt} ${NEWLINE_CHAR} `;
  

  
  return (
    <Box p={2}>
      <Grid direction="row" alignItems="center" justifyContent="flex-end">
        {/* <Grid item xs={2}>
          <Typography color="textPrimary" variant="body2">
            <div>
              {t("Share")}
            </div>
          </Typography>
        </Grid> */}
        <Grid item xs={12} justifyContent="flex-end" container>
          <Box m={1}>
            <Typography color="textPrimary" variant="body2">
              <div>{t("Share")}</div>
            </Typography>
          </Box>
          <EmailIcon
            style={{ cursor: "pointer" }}
            size={ICONS_SIZE}
            onClick={() => {
              setShareOpen(true);
            }}
          ></EmailIcon>

          {/* <WhatsappShareButton title={shareText} url={addressLink}>
            <WhatsappIcon size={ICONS_SIZE}></WhatsappIcon>
          </WhatsappShareButton> */}

          
          <WhatsappShareButton title={isLangArActive ? formatedAddressMessageAr : formatedAddressMessageEn} url={addressLink}>
            <WhatsappIcon size={ICONS_SIZE}></WhatsappIcon>
          </WhatsappShareButton>

          {/* <LinkedinShareButton url={addressLink} title={shareText} summary={shareSummary}>
            <LinkedinIcon size={ICONS_SIZE}></LinkedinIcon>
          </LinkedinShareButton>

          <FacebookShareButton
            url={addressLink}
            quote={shareText}
            hashtag={[shareHashTag]}
          >
            <FacebookIcon size={ICONS_SIZE}></FacebookIcon>
          </FacebookShareButton>

          <FacebookMessengerShareButton
            url={addressLink}
            appId="521270401588372"
          >
            <FacebookMessengerIcon size={ICONS_SIZE}></FacebookMessengerIcon>
          </FacebookMessengerShareButton>

          <TwitterShareButton url={addressLink} title={shareText} hashtags={[shareHashTag]}>
            <TwitterIcon size={ICONS_SIZE} />
          </TwitterShareButton> */}
        </Grid>
        {/* <Grid item xs={1}></Grid> */}
      </Grid>
    </Box>
  );
}

export default ShareAddressComponent;
